// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"dbe3cd6f","980":"dfab73d7"}[chunkId] + ".chunk.css";
};